export default {
	FileManager: 'Media Manager',
	Upload: 'Upload',
	GlobalMedia: 'a global media',
	NoGlobalMedia: 'No global media yet. Add one',
	LocalMedia: 'a local media',
	NoLocalMedia: 'No local media yet. Add one',
	ApplicationMedia: 'an application media',
	NoApplicationMedia: 'No application media yet.',
	ChooseMedia: 'Choose this media',
	Preview: 'File Preview',
	Download: 'Download',
	Remove: 'Remove',
	RemoveFile: 'Remove {fileName}',
	GoBack: 'Go back to media',
	RemoveFileDescription: 'Are you sur you want to remove {fileName}?',
	Close: 'Close',
	ConfirmText: 'Confirm',
};
